import React, { Component, Fragment } from 'react';

import { checkUndefine, capitalizeFirstLetter, stringToUrlSlug, vietnameseStringToUnicode, formatUrlSlug } from '../../../../../../../helpers/functions';
import { 
    TOUR as TOUR_ENUM, 
    UPLOAD_DIRECTORY, 
    DATE_TIME_FORMAT, 
    DETAIL_ACTIONS, 
    INSTALLMENT as INSTALLMENT_ENUM, 
    DEFAULT_TOUR_PROPERTY, 
    CAMPAIGN as CAMPAIGN_ENUM,
    ORDER, 
} from '../../../../../../../constants/Define';

import {
    FormWrapperInputComponent,
    DatePickerComponent,
} from "../../../../../common/component/Index";
import Wrapper from '../../../../../common/component/Wrapper';
import Input from '../../../../../common/component/Input';
import Radio from '../../../../../common/component/Radio';
import AntSelect, { AntOption } from '../../../../../common/component/AntSelect';
import TagSearch from '../../../../../common/component/TagSearch';
import Span from '../../../../../common/component/Span';
import CheckboxCom from '../../../../../common/component/Checkbox';
import TextArea from '../../../../../common/component/TextArea';
import Switch from '../../../../../common/component/Switch';
import RichTextEditor, { ClassicEditor } from '../../../../../common/component/RichTextEditor';

import { message, Tabs, Icon } from 'antd'

import TourTypes from './TourTypes';
import TagSKUVW from './TagSKUVW';

import { cloneDeep, find, property, isEqual, toArray } from 'lodash';
import { Rate, Divider, Tooltip, Checkbox } from 'antd';

import moment from 'moment';
import * as Func from "../../../../../../../helpers/functions";

import './GeneralInfo.less';
import Select, { Option } from '../../../../../common/component/Select';

const { TabPane } = Tabs
const CheckboxGroup = Checkbox.Group

export default class GeneralInfo extends Component {
    constructor(props) {
        super(props);

        this.newTabIndex = 0;
        // this.initInfo = [
        //     { title: 'Mô tả', content: '' },
        //     { title: 'Bao gồm', content: '' },
        //     { title: 'Điều khoản', content: '' },
        //     { title: 'Chính sách hoàn huỷ', content: '' },
        //     { title: 'Hướng dẫn sử dụng', content: '' }
        // ]
        this.state = {
            urlSlugEdited: this.props.tour && !!this.props.tour.urlSlug,
            // extraInfos: this.props.tour && this.props.tour.extraInfos,
            activeKey: '0'
        };
    }

    componentWillReceiveProps(nextProps) {
        // if (nextProps.tour && !JSON.stringify(nextProps.tour) !== JSON.stringify(this.props.tour)) {
        //     this.setState({ extraInfos: cloneDeep(nextProps.tour.extraInfos )});
        // }
    }

    getMemberShipTypeEnums() {
        return toArray(CAMPAIGN_ENUM.MEMBER_SHIP_TYPE_TOUR);
    }

    _onChangeMemberShip = list => {
        this.props.onChangeMemberShip(list)
    };

    getChannels(type) {
        if(type === ORDER.TYPES.VINWONDER_NEW.id){
            return toArray(TOUR_ENUM.CHANNELS);
        }
        return toArray(TOUR_ENUM.CHANNELS).filter(x=>x.value !== TOUR_ENUM.CHANNELS.VinWonders.value);
    }
    getShowTicketInfo(type) {
        if(type === ORDER.TYPES.VINWONDER_NEW.id){
            return toArray(TOUR_ENUM.TICKET_INFO_ENUM);
        }
        return [];
    }

    render() {
        const { t, tour, validation, validateTabContent, action, tourTypes, departures, destinations, supplierSelectData, listProperties, _tagSKUs, supplierAll, tagsSKUVW } = this.props;
        const isInstallment = tour.installmentFee || tour.installmentLimit
        return (
            <Wrapper className="tour-detail-general-info row">
                <Wrapper className="col-md-6">
                    <FormWrapperInputComponent
                        typeInput={true}
                        isRequired={'right'}
                        isValidation={true}
                        dataValidation={tour.tourName}
                        validation={validation.tourName}
                        messageBelowInput={true}
                        labelTitle={t(`item.tour.tourName`)}
                    >
                        <Input placeholder="" type={`text`}
                            className={`form-control`}
                            name={`tourName`} onChange={this.onChangeTourName}
                            value={checkUndefine(tour.tourName)} />
                    </FormWrapperInputComponent>
                </Wrapper>

                <Wrapper className="col-md-6">
                    <FormWrapperInputComponent
                        typeInput={true}
                        isRequired={'right'}
                        isValidation={true}
                        dataValidation={tour.type}
                        validation={validation.type}
                        messageBelowInput={true}
                        labelTitle={t(`item.tour.type`)}
                        // visible={action !== DETAIL_ACTIONS.UPDATE && action !== DETAIL_ACTIONS.TRANSLATE}
                    >
                        <Wrapper style={{ display: 'flex' }}>
                            <AntSelect className="select-lengthOfTour"
                                showArrow showSearch
                                disabled={action === DETAIL_ACTIONS.UPDATE || action === DETAIL_ACTIONS.TRANSLATE}
                                placeholder={capitalizeFirstLetter((t('placeHolderForm.select') + " " + t("item.tour.type")).toLowerCase())}
                                value={tour.type}
                                onChange={(value) => this.onChangeType(value)}
                                style={{ width: '100%' }}
                                filterOption={this.selectFilterSearch}
                            >
                                {DEFAULT_TOUR_PROPERTY.map((item, index) => {
                                    return item.sku && <AntOption key={index} value={item.value}>{item.label}</AntOption>
                                })}
                            </AntSelect>
                        </Wrapper>
                    </FormWrapperInputComponent>
                </Wrapper>
                
                <Wrapper className="col-md-6" style={{ visibility: action === 'CREATE' && 'hidden' }}>
                    <FormWrapperInputComponent
                        typeInput={true}
                        labelTitle={t(`item.tour.tourCode`)}
                        visible={action !== DETAIL_ACTIONS.TRANSLATE}
                    >
                        <Input placeholder="" type={`text`} className={`form-control`} name={`tourCode`} value={checkUndefine(tour.tourCode)} disabled />
                    </FormWrapperInputComponent>
                </Wrapper>

                <Wrapper className="col-md-6">
                    <FormWrapperInputComponent
                        typeInput={true}
                        labelTitle="Event zone"
                        visible={action !== DETAIL_ACTIONS.TRANSLATE}
                    >
                        <Input placeholder="" type="text"
                            className="form-control"
                            name="eventZone"
                            onChange={(e) => this.props.onChange('eventZone', e.target.value)}
                            value={checkUndefine(tour.eventZone)} />
                    </FormWrapperInputComponent>
                </Wrapper>

                {
                    tour.type === 7 ?
                    <Wrapper className="col-md-6">
                        <FormWrapperInputComponent
                            typeInput={true}
                            isRequired={'right'}
                            isValidation={true}
                            dataValidation={tour.supplierId}
                            validation={validation.supplierId}
                            messageBelowInput={true}
                            labelTitle={t(`item.tour.selectSupplier`)}
                        >
                            <Wrapper style={{ display: 'flex' }}>
                                <AntSelect className="select-lengthOfTour"
                                    showArrow showSearch
                                    // disabled={action === DETAIL_ACTIONS.UPDATE || action === DETAIL_ACTIONS.TRANSLATE}
                                    placeholder={t("item.tour.selectSupplier").toLowerCase()}
                                    value={tour.supplierId}
                                    onChange={(value) => this.props.onChange('supplierId', value)}
                                    style={{ width: '100%' }}
                                    filterOption={this.selectFilterSearch}
                                >
                                    {supplierAll.map((sp) => (
                                        <AntOption key={sp.id} value={sp.id}>
                                            {sp.supplierName}
                                        </AntOption>
                                        ))}
                                </AntSelect>
                            </Wrapper>
                        </FormWrapperInputComponent>
                    </Wrapper>
                    : 
                    <Wrapper className="col-md-6"></Wrapper>
                }
                
                {/* Đối tượng áp dung */ }
                <Fragment>
                    <Wrapper className="col-md-6">
                        <FormWrapperInputComponent
                            isValidation={ true }
                            typeInput={true}
                            isRequired={tour.objectType === 'MEMBER' ? 'right' : false}
                            labelTitle={ t("item.tour.useObjectHeader") }
                            validation={ validation.memberShipTypes }
                            messageBelowInput={ true }
                            labelHeaderStart={true}
                        >
                            <Wrapper>
                                <Radio.Group 
                                    value={ tour.objectType } 
                                    onChange={ e => this.props.onChange('objectType', e.target.value) } 
                                    // disabled={ !campaign.canEdit }
                                >
                                    { toArray(CAMPAIGN_ENUM.OBJECT_TYPE).filter(item => item.key !== 'another').map(item => (
                                        this.renderInfoTooltip(t(`item.campaign.objectType.description.${ item.key }`), (
                                            <Radio key={ item.key } value={ item.value } className="mr-0">
                                                { t(`item.campaign.objectType.${ item.key }`) }
                                            </Radio>
                                        ), 'mr-3')
                                    )) }
                                </Radio.Group>
                                { tour.objectType === CAMPAIGN_ENUM.OBJECT_TYPE.MEMBER.id && 
                                    <CheckboxGroup
                                        className="m-t"
                                        options={ this.getMemberShipTypeEnums() }
                                        value={ tour.memberShipTypes.length > 0 ? 
                                            tour.memberShipTypes.map((item)=>
                                                typeof item === 'string' ? CAMPAIGN_ENUM.MEMBER_SHIP_TYPE_TOUR[item]?.value : item
                                            ) : []}
                                        onChange={ this._onChangeMemberShip }
                                    /> 
                                }
                            </Wrapper>
                        </FormWrapperInputComponent>
                    </Wrapper>
                </Fragment>
                <Wrapper className="col-md-6">
                    <FormWrapperInputComponent
                        typeInput={true}
                        labelTitle={t(`item.tour.tourOperationType`)}
                        visible={action !== DETAIL_ACTIONS.TRANSLATE}
                    >
                        <Radio.Group value={tour.tourOperationType}
                            onChange={e => this.props.onChange('tourOperationType', e.target.value)}>
                            {Object.keys(TOUR_ENUM.OPERATION_TYPE).map(type => (
                                <Radio key={TOUR_ENUM.OPERATION_TYPE[type]} value={TOUR_ENUM.OPERATION_TYPE[type]}>{t(`item.tour.${type.toLowerCase()}`)}</Radio>
                            ))}
                        </Radio.Group>
                    </FormWrapperInputComponent>
                </Wrapper>
                <Wrapper className="col-md-6">
                    <FormWrapperInputComponent
                        typeInput={true}
                        isRequired={'right'}
                        isValidation={true}
                        dataValidation={tour.tourTypes}
                        validation={validation.tourTypes}
                        messageBelowInput={true}
                        labelTitle={t(`item.tour.tourTypes`)}
                        visible={action !== DETAIL_ACTIONS.TRANSLATE}
                    >
                        <TourTypes tourTypes={tourTypes}
                            selections={tour.tourTypes}
                            onChange={this.onChangeTourTypes}
                            filterOption={this.selectFilterSearch}
                            onCreate={this.props.onCreateTourType}
                            onUpdate={this.props.onUpdateTourType}
                            onDelete={this.props.onDeleteTourType}
                        />
                    </FormWrapperInputComponent>
                </Wrapper>
                <Wrapper className="col-md-6">
                    <FormWrapperInputComponent
                        typeInput={true}
                        // isRequired={'right'}
                        // isValidation={true}
                        // dataValidation={tour.departure && tour.departure.id}
                        // validation={validation.departure}
                        messageBelowInput={true}
                        labelTitle={t(`item.tour.departure`)}
                        visible={action !== DETAIL_ACTIONS.TRANSLATE}
                    >
                        <AntSelect className="select-departure"
                            showArrow showSearch
                            placeholder={capitalizeFirstLetter((t('placeHolderForm.select') + " " + t("item.tour.departure")).toLowerCase())}
                            value={tour.departure && tour.departure.id}
                            onChange={this.onChangeDeparture}
                            style={{ width: '100%' }}
                            filterOption={this.selectFilterSearch}
                        >
                            {departures.map(d => (
                                <AntOption key={d.id} value={d.id}>{d.name}</AntOption>
                            ))}
                        </AntSelect>
                    </FormWrapperInputComponent>
                </Wrapper>
                <Wrapper className="col-md-6">
                    <FormWrapperInputComponent
                        typeInput={true}
                        isRequired={'right'}
                        isValidation={true}
                        dataValidation={tour.destination && tour.destination.id}
                        validation={validation.destination}
                        messageBelowInput={true}
                        labelTitle={t(`item.tour.destination`)}
                        visible={action !== DETAIL_ACTIONS.TRANSLATE}
                    >
                        <AntSelect className="select-destination"
                            showArrow showSearch
                            placeholder={capitalizeFirstLetter((t('placeHolderForm.select') + " " + t("item.tour.destination")).toLowerCase())}
                            value={tour.destination && tour.destination.id}
                            onChange={this.onChangeDestination}
                            style={{ width: '100%' }}
                            filterOption={this.selectFilterSearch}
                        >
                            {destinations.map(d => (
                                <AntOption key={d.id} value={d.id}>{d.name}</AntOption>
                            ))}
                        </AntSelect>
                    </FormWrapperInputComponent>
                </Wrapper>
                <Wrapper className="col-md-6">
                    <FormWrapperInputComponent
                        typeInput={true}
                        isValidation={false}
                        dataValidation={tour.tourTypes}
                        validation={validation.tourTypes}
                        messageBelowInput={true}
                        labelTitle={t(`item.tour.tagSKUVW`)}
                        visible={action !== DETAIL_ACTIONS.TRANSLATE}
                    >
                        <TagSKUVW tags={tagsSKUVW}
                            selections={tour.tagsSKUVW}
                            onChange={this.onChangeTagSKUVW}
                            filterOption={this.selectFilterSearch}
                            onCreate={this.props.onCreateTagSKUVW}
                            onUpdate={this.props.onUpdateTagSKUVW}
                            onDelete={this.props.onDeleteTagSKUVW}
                        />
                    </FormWrapperInputComponent>
                </Wrapper>
               

                <Wrapper className="col-md-6">
                    <FormWrapperInputComponent
                        isRequired={'right'}
                        isValidation={true}
                        dataValidation={tour.channel}
                        validation={validation.channel}
                        messageBelowInput={true}
                        typeInput={true}
                        labelTitle={t(`item.tour.channel`)}
                        visible={action !== DETAIL_ACTIONS.TRANSLATE}
                    >
                        <CheckboxGroup
                            options={ this.getChannels(tour.type) }
                            value={ tour.channel || []}
                            onChange={e => this.props.onChange('channel', e)}
                        />
                    </FormWrapperInputComponent>
                </Wrapper>

                {/* <Wrapper className="col-md-6"></Wrapper> */}

                <Wrapper className="col-md-6">
                    <FormWrapperInputComponent
                        typeInput={true}
                        labelTitle={t(`item.tour.airline`)}
                        visible={action !== DETAIL_ACTIONS.TRANSLATE}
                    >
                        <Wrapper style={{ display: 'flex' }}>
                            <AntSelect className="select-airline"
                                showArrow showSearch
                                placeholder={capitalizeFirstLetter((t('placeHolderForm.select') + " " + t("item.tour.airline")).toLowerCase())}
                                value={tour.airline}
                                onChange={(value) => this.props.onChange('airline', value)}
                                style={{ width: '100%' }}
                                filterOption={this.selectFilterSearch}
                            >
                                {TOUR_ENUM.AIRLINE_ENUM.map((value, index) => {
                                    return <AntOption key={index} value={value}>{value}</AntOption>
                                })}
                            </AntSelect>
                        </Wrapper>
                    </FormWrapperInputComponent>
                </Wrapper>
                <Wrapper className="col-md-6">
                    <FormWrapperInputComponent
                        typeInput={true}
                        isValidation={true}
                        dataValidation={tour.hotel}
                        validation={validation.hotel}
                        messageBelowInput={true}
                        labelTitle={t(`item.tour.hotel`)}
                        className="mb-0"
                        visible={action !== DETAIL_ACTIONS.TRANSLATE}
                    >
                        <Wrapper>
                            <Rate value={tour.hotel && tour.hotel.rating} onChange={(value) => this.props.onChange('hotel', { ...(tour.hotel || {}), rating: value })} />
                        </Wrapper>
                    </FormWrapperInputComponent>
                </Wrapper>
                <Wrapper className="col-md-6">
                    <FormWrapperInputComponent
                        typeInput={true}
                        messageBelowInput={true}
                        labelTitle={t(`item.tour.propertyName`)}
                        visible={action !== DETAIL_ACTIONS.TRANSLATE}
                    >
                        <AntSelect className="select-types"
                            showArrow
                            mode="multiple"
                            placeholder={capitalizeFirstLetter((t('placeHolderForm.select') + " " + t("item.tour.propertyName")).toLowerCase())}
                            value={tour.properties}
                            onChange={properties => this.props.onChange('properties', properties)}
                            style={{ width: '100%' }}
                        >
                            {(listProperties || []).map(property => (
                                <AntOption key={property.id} value={property.id}>
                                    {property.name}
                                </AntOption>
                            ))}
                        </AntSelect>
                    </FormWrapperInputComponent>
                </Wrapper>
                <Wrapper className="col-md-6">
                    <FormWrapperInputComponent
                        typeInput={true}
                        labelTitle={t(`item.tour.order`)}
                        visible={action !== DETAIL_ACTIONS.TRANSLATE}
                    >
                        <Input placeholder="" type={`text`}
                            className={`form-control`}
                            name={`order`} onChange={(e) => this.props.onChange('order', Number(e.target.value))}
                            value={checkUndefine(tour.order)} />
                    </FormWrapperInputComponent>
                </Wrapper>
                <Wrapper className="col-md-6">
                    <FormWrapperInputComponent
                        typeInput={true}
                        isRequired={'right'}
                        isValidation={true}
                        dataValidation={tour.productTypes}
                        validation={validation.productTypes}
                        messageBelowInput={true}
                        labelTitle={t(`item.tour.productTypes`)}
                        visible={action !== DETAIL_ACTIONS.TRANSLATE}
                    >

                        <AntSelect className="select-types"
                            showArrow
                            mode="multiple"
                            placeholder={capitalizeFirstLetter((t('placeHolderForm.select') + " " + t("item.tour.productTypes")).toLowerCase())}
                            value={tour.productTypes}
                            onChange={e => this.props.onChange('productTypes', e)}
                            style={{ width: '100%' }}
                        >
                            {(TOUR_ENUM.PRODUCT_TYPES_ENUM || []).map(productType => (
                                <AntOption key={productType.id} value={productType.id}>
                                    {t(`item.tour.productTypeTrans.${productType.key}`)}
                                </AntOption>
                            ))}
                        </AntSelect>
                    </FormWrapperInputComponent>
                </Wrapper>
                <Wrapper className="col-md-6">
                    <FormWrapperInputComponent
                        typeInput={true}
                        messageBelowInput={true}
                        labelTitle={t(`item.tour.tag`)}
                    >
                        <Input placeholder="" type={`text`}
                            className={`form-control`}
                            name={`tag`}
                            onChange={(e) => this.props.onChange('tag', e.target.value)}
                            value={checkUndefine(tour.tag)} />
                    </FormWrapperInputComponent>
                </Wrapper>
                <Wrapper className="col-md-6">
                    <FormWrapperInputComponent
                        typeInput={true}
                        messageBelowInput={true}
                        isRequired={isInstallment ? 'right' : false}
                        isValidation={true}
                        dataValidation={tour.installmentFee}
                        validation={validation.installmentFee}
                        labelTitle={t(`item.group.installmentFee`)}
                        visible={action !== DETAIL_ACTIONS.TRANSLATE}
                    >
                        <Wrapper style={{ display: 'flex' }}>
                            <AntSelect
                                placeholder={capitalizeFirstLetter((t('placeHolderForm.select') + " " + t("item.group.installmentFee")).toLowerCase())}
                                value={tour.installmentFee}
                                onChange={(e) => this.props.onChange('installmentFee', e)}
                                style={{ width: '100%' }}
                            >
                                <Option key={0} value=''>{t(`item.group.installmentFee_enum.UN_KNOW`)}</Option>
                                {INSTALLMENT_ENUM.INSTALLMENT_FREE.map((value, index) => {
                                    return <AntOption key={index + 1} value={value}>{t(`item.group.installmentFee_enum.${value}`)}</AntOption>
                                })}
                            </AntSelect>
                        </Wrapper>
                    </FormWrapperInputComponent>
                </Wrapper>
                <Wrapper className="col-md-6">
                    <FormWrapperInputComponent
                        typeInput={true}
                        messageBelowInput={true}
                        isRequired={isInstallment ? 'right' : false}
                        isValidation={true}
                        dataValidation={tour.installmentLimit}
                        validation={validation.installmentLimit}
                        labelTitle={t(`item.group.installmentLimit`)}
                        visible={action !== DETAIL_ACTIONS.TRANSLATE}
                    >
                        <Wrapper style={{ display: 'flex' }}>
                            <AntSelect
                                placeholder={capitalizeFirstLetter((t('placeHolderForm.select') + " " + t("item.group.installmentLimit")).toLowerCase())}
                                value={tour.installmentLimit}
                                onChange={(e) => this.props.onChange('installmentLimit', e)}
                                style={{ width: '100%' }}
                            >
                                <Option key={0} value=''>{t(`item.group.installmentLimit_enum.UN_KNOW`)}</Option>
                                {Object.keys(INSTALLMENT_ENUM.INSTALLMENT_LIMIT).map((value, index) => {
                                    return <AntOption key={index + 1} value={INSTALLMENT_ENUM.INSTALLMENT_LIMIT[value]}>{t(`item.group.installmentLimit_enum.${value}`)}</AntOption>
                                })}
                            </AntSelect>
                        </Wrapper>
                    </FormWrapperInputComponent>
                </Wrapper>
                {
                    tour.type !== 7 ?
                    <Wrapper className="col-md-6">
                        <FormWrapperInputComponent
                            typeInput={true}
                            isRequired={'right'}
                            isValidation={true}
                            dataValidation={tour.lengthOfTour}
                            validation={validation.lengthOfTour}
                            messageBelowInput={true}
                            labelTitle={t(`item.tour.lengthOfTour`)}
                            visible={action !== DETAIL_ACTIONS.TRANSLATE}
                        >
                            <Wrapper style={{ display: 'flex' }}>
                                <AntSelect className="select-lengthOfTour"
                                    showArrow showSearch
                                    placeholder={capitalizeFirstLetter((t('placeHolderForm.select') + " " + t("item.tour.lengthOfTour")).toLowerCase())}
                                    value={this.getEnumLengthOfTour(tour.lengthOfTour)}
                                    onChange={(value) => this.props.onChange('lengthOfTour', value)}
                                    style={{ width: '100%' }}
                                    filterOption={this.selectFilterSearch}
                                    disabled={action !== DETAIL_ACTIONS.CREATE}
                                >
                                    {TOUR_ENUM.LENGTHOFTOUR.map((value, index) => {
                                        return <AntOption key={index} value={value}>{this.getEnumLengthOfTour(value)}</AntOption>
                                    })}
                                </AntSelect>
                            </Wrapper>
                        </FormWrapperInputComponent>
                    </Wrapper>
                    :
                    <Wrapper className="col-md-6"></Wrapper>
                }
                <Divider />
                <Wrapper className="col-md-6">
                    <FormWrapperInputComponent
                        typeInput={true}
                        labelTitle={t(`item.tour.attribute`)}
                        visible={action !== DETAIL_ACTIONS.TRANSLATE}
                    >
                        <Wrapper className="tour-attribute-content">
                            <Span className="">
                                <CheckboxCom className="mr-1" checked={tour.isSpecial} onChange={e => this.props.onChange('isSpecial', e.target.checked)} />
                                {t(`item.tour.isSpecial`)}
                            </Span>
                            <Span className="ml-3 mr-3">
                                <CheckboxCom className="mr-1" checked={tour.isHotTour} onChange={e => this.props.onChange('isHotTour', e.target.checked)} />
                                {t(`item.tour.isHotTour`)}
                            </Span>
                            <Span className="ml-3 mr-3">
                                <CheckboxCom className="mr-1" checked={tour.isEnabled} onChange={e => this.props.onChange('isEnabled', e.target.checked)} />
                                {t(`item.tour.isEnabled`)}
                            </Span>
                            <Span className="ml-3 mr-3">
                                <CheckboxCom className="mr-1" checked={tour.isWebsitePublished} onChange={e => this.props.onChange('isWebsitePublished', e.target.checked)} />
                                {t(`item.tour.isWebsitePublished`)}
                            </Span>
                            {tour.type === ORDER.TYPES.VINWONDER_NEW.id && 
                                <Span className="ml-3 mr-3">
                                    <CheckboxCom className="mr-1"
                                        checked={tour.isCrossSell}
                                        onChange={e => this.props.onChange('isCrossSell', e.target.checked)}
                                    />
                                    {t(`item.tour.isCrossSell`)}
                                </Span>
                            }
                        </Wrapper>
                    </FormWrapperInputComponent>
                </Wrapper>
                <Wrapper className="col-md-6"></Wrapper>
                <Wrapper className="col-md-6">
                    <FormWrapperInputComponent
                        typeInput={true}
                        labelTitle={t(`item.tour.urlSlug`)}
                        visible={action !== DETAIL_ACTIONS.TRANSLATE}
                    >
                        <Input placeholder="" type={`text`}
                            className={`form-control`}
                            name={`urlSlug`} onChange={this.onChangeUrlSlug}
                            value={checkUndefine(tour.urlSlug)} />
                    </FormWrapperInputComponent>
                </Wrapper>
                <Wrapper className="col-md-6">
                    <FormWrapperInputComponent
                        typeInput={true}
                        isRequired={tour.isWebsitePublished && 'right'}
                        isValidation={tour.isWebsitePublished}
                        dataValidation={tour.saleStartDate}
                        validation={validation.saleStartDate}
                        labelTitle={t(`item.tour.saleDate`)}
                        messageBelowInput={true}
                        visible={action !== DETAIL_ACTIONS.TRANSLATE}
                    >
                        <DatePickerComponent className={`form-control applyDates w100-percent`}
                            disabledDate={this.disabledPublishDate}
                            hmsComponent={`RangePicker`} format={DATE_TIME_FORMAT.DATE_TIME}
                            showTime={{ format: DATE_TIME_FORMAT.SHORT_TIME }}
                            style={{ padding: 0, border: 0 }}
                            onChange={(data) => this.onSelectDateRange(data, 'saleStartDate', 'saleEndDate')} name={`applyDates`}
                            placeholder={[t('placeHolderForm.startDate'), t('placeHolderForm.endDate')]}
                            value={[tour.saleStartDate, tour.saleEndDate]}
                        // disabled={!tour.stayStartDate}
                        />
                    </FormWrapperInputComponent>
                </Wrapper>
                <Wrapper className="col-md-6">
                    <FormWrapperInputComponent
                        isRequired={true}
                        typeInput={true}
                        className="mb-0"
                        isValidation={true}
                        dataValidation={tour.shortDescription}
                        validation={validation.shortDescription}
                        labelTitle={t(`item.tour.shortDescription`)}
                        messageBelowInput={true}
                    >
                        <TextArea
                            className="form-control" name="shortDescription" onChange={e => this.props.onChange('shortDescription', e.target.value)}
                            value={checkUndefine(tour.shortDescription)} />
                    </FormWrapperInputComponent>
                </Wrapper>
                {
                    tour.type !== 7 ? 
                    <Wrapper className="col-md-6">
                        <FormWrapperInputComponent
                            typeInput={true}
                            isRequired={tour.isWebsitePublished && 'right'}
                            isValidation={tour.isWebsitePublished}
                            dataValidation={tour.stayStartDate}
                            validation={validation.stayStartDate}
                            labelTitle={t(`item.tour.stayDate`)}
                            messageBelowInput={true}
                            visible={action !== DETAIL_ACTIONS.TRANSLATE}
                        >
                            <DatePickerComponent className={`form-control applyDates w100-percent`}
                                disabledDate={this.disabledPublishDate}
                                hmsComponent={`RangePicker`} format={DATE_TIME_FORMAT.DATE_TIME}
                                showTime={{ format: DATE_TIME_FORMAT.SHORT_TIME }}
                                style={{ padding: 0, border: 0 }}
                                onChange={(data) => this.onSelectDateRange(data, 'stayStartDate', 'stayEndDate')} name={`applyDates`}
                                placeholder={[t('placeHolderForm.startDate'), t('placeHolderForm.endDate')]}
                                value={[tour.stayStartDate, tour.stayEndDate]}
                            />
                        </FormWrapperInputComponent>
                    </Wrapper> : 
                    <Wrapper className="col-md-6"></Wrapper>
                }
                <Wrapper className="col-md-6"></Wrapper>
                {
                    tour.type !== 7 ? 
                    <Wrapper className="col-md-6">
                        <FormWrapperInputComponent
                            typeInput={true}
                            isRequired={'right'}
                            isValidation={true}
                            dataValidation={tour.effectiveStartDate}
                            validation={validation.effectiveStartDate}
                            labelTitle={t(`item.tour.effectiveDate`)}
                            messageBelowInput={true}
                            visible={action !== DETAIL_ACTIONS.TRANSLATE}
                        >
                            <DatePickerComponent className={`form-control applyDates w100-percent`}
                                disabledDate={this.disabledPublishDate}
                                hmsComponent={`RangePicker`} format={DATE_TIME_FORMAT.DATE_TIME}
                                showTime={{ format: DATE_TIME_FORMAT.SHORT_TIME }}
                                style={{ padding: 0, border: 0 }}
                                onChange={(data) => this.onSelectDateRange(data, 'effectiveStartDate', 'effectiveEndDate')} name={`applyDates`}
                                placeholder={[t('placeHolderForm.startDate'), t('placeHolderForm.endDate')]}
                                value={[tour.effectiveStartDate, tour.effectiveEndDate]}
                            />
                        </FormWrapperInputComponent>
                        </Wrapper>
                        : 
                        <Wrapper className="col-md-6"></Wrapper>
                }
                <Wrapper className="col-md-6"></Wrapper>
                { tour.type === 1 && 
                    <Fragment>
                        <Wrapper className="col-md-6">
                            <FormWrapperInputComponent
                                typeInput={true}
                                labelTitle={t(`item.tour.voucherBookingPeriod`)}
                                messageBelowInput={true}
                                isRequired={'right'}
                                isValidation={true}
                                dataValidation={tour.voucherBookingPeriod}
                                validation={validation.voucherBookingPeriod}
                                visible={action !== DETAIL_ACTIONS.TRANSLATE}
                            >
                                <DatePickerComponent className={`form-control`}
                                    allowClear={false}
                                    format={DATE_TIME_FORMAT.SHORT_DATE}
                                    disabledDate={(current) => current && current < moment().add(-1, 'day')}
                                    style={{ padding: 0, border: 0 }}
                                    onChange={data => this.props.onChange('voucherBookingPeriod', data.fullValue)}
                                    name={`applyDates`}
                                    placeholder={t('item.tour.voucherBookingPeriodPlaceHolder')}
                                    value={tour.voucherBookingPeriod}
                                />
                            </FormWrapperInputComponent>
                        </Wrapper>
                        <Wrapper className="col-md-6">

                        </Wrapper>
                    </Fragment>
                }
                {
                    tour.type !== 7 ? 
                    <Wrapper className="col-md-6">
                        <FormWrapperInputComponent
                            typeInput={true}
                            messageBelowInput={true}
                            isRequired={'right'}
                            isValidation={true}
                            dataValidation={tour.cutOffDate}
                            validation={validation.cutOffDate}
                            labelTitle={t(`item.tour.cutOffDate`)}
                            visible={action !== DETAIL_ACTIONS.TRANSLATE}
                        >
                            <Input placeholder="" type={`text`}
                                className={`form-control`}
                                name={`cutOffDate`} onChange={(e) => this.props.onChange('cutOffDate', Number(e.target.value))}
                                value={checkUndefine(tour.cutOffDate)} />
                        </FormWrapperInputComponent>
                    </Wrapper> : 
                    <Wrapper className="col-md-6"></Wrapper>
                }
                <Wrapper className="col-md-6"></Wrapper>
                {
                    (tour.type !== 1 && tour.type !== 7) &&
                    <Wrapper className="col-md-6">
                        <FormWrapperInputComponent
                            typeInput={true}
                            messageBelowInput={true}
                            isRequired={'right'}
                            isValidation={true}
                            dataValidation={tour.bookingPeriod}
                            validation={validation.bookingPeriod}
                            labelTitle={t(`item.tour.bookingPeriod`)}
                            visible={action !== DETAIL_ACTIONS.TRANSLATE}
                        >
                            <Input placeholder="" type={`text`}
                                className={`form-control`}
                                name={`bookingPeriod`} onChange={(e) => this.props.onChange('bookingPeriod', Number(e.target.value))}
                                value={checkUndefine(tour.bookingPeriod)} />
                        </FormWrapperInputComponent>
                    </Wrapper>
                }
                
                {/* <Divider /> */}
                {/* <Wrapper className="col-md-6">
                    <FormWrapperInputComponent
                        typeInput={true}
                        messageBelowInput={true}
                        labelTitle={t(`item.tour.vehicle`)}
                        visible={action !== DETAIL_ACTIONS.TRANSLATE}
                    >
                        <AntSelect className="select-departure"
                            showArrow showSearch allowClear
                            placeholder={capitalizeFirstLetter((t('placeHolderForm.select') + " " + t("item.tour.vehicle")).toLowerCase())}
                            value={tour.vehicleId}
                            onChange={id => this.props.onChange('vehicleId', id)}
                            style={{ width: '100%' }}
                            filterOption={this.selectFilterSearch}
                        >
                            {(supplierSelectData.vehicles || []).map(d => (
                                <AntOption key={d.id} value={d.id}>{d.supplierName}</AntOption>
                            ))}
                        </AntSelect>
                    </FormWrapperInputComponent>
                </Wrapper>
                <Wrapper className="col-md-6">
                    <FormWrapperInputComponent
                        typeInput={true}
                        messageBelowInput={true}
                        labelTitle={t(`item.tour.accommodation`)}
                        visible={action !== DETAIL_ACTIONS.TRANSLATE}
                    >
                        <AntSelect className="select-departure"
                            showArrow showSearch allowClear
                            placeholder={capitalizeFirstLetter((t('placeHolderForm.select') + " " + t("item.tour.accommodation")).toLowerCase())}
                            value={tour.accommodationId}
                            onChange={id => this.props.onChange('accommodationId', id)}
                            style={{ width: '100%' }}
                            filterOption={this.selectFilterSearch}
                        >
                            {(supplierSelectData.accommodations || []).map(d => (
                                <AntOption key={d.id} value={d.id}>{d.supplierName}</AntOption>
                            ))}
                        </AntSelect>
                    </FormWrapperInputComponent>
                </Wrapper>
                <Wrapper className="col-md-6">
                    <FormWrapperInputComponent
                        typeInput={true}
                        messageBelowInput={true}
                        labelTitle={t(`item.tour.activity`)}
                        visible={action !== DETAIL_ACTIONS.TRANSLATE}
                    >
                        <AntSelect className="select-departure"
                            showArrow showSearch allowClear
                            placeholder={capitalizeFirstLetter((t('placeHolderForm.select') + " " + t("item.tour.activity")).toLowerCase())}
                            value={tour.activityId}
                            onChange={id => this.props.onChange('activityId', id)}
                            style={{ width: '100%' }}
                            filterOption={this.selectFilterSearch}
                        >
                            {(supplierSelectData.activities || []).map(d => (
                                <AntOption key={d.id} value={d.id}>{d.supplierName}</AntOption>
                            ))}
                        </AntSelect>
                    </FormWrapperInputComponent>
                </Wrapper>
                <Wrapper className="col-md-6">
                    <FormWrapperInputComponent
                        typeInput={true}
                        messageBelowInput={true}
                        labelTitle={t(`item.tour.meal`)}
                        visible={action !== DETAIL_ACTIONS.TRANSLATE}
                    >
                        <AntSelect className="select-departure"
                            showArrow showSearch allowClear
                            placeholder={capitalizeFirstLetter((t('placeHolderForm.select') + " " + t("item.tour.meal")).toLowerCase())}
                            value={tour.mealId}
                            onChange={id => this.props.onChange('mealId', id)}
                            style={{ width: '100%' }}
                            filterOption={this.selectFilterSearch}
                        >
                            {(supplierSelectData.meals || []).map(d => (
                                <AntOption key={d.id} value={d.id}>{d.supplierName}</AntOption>
                            ))}
                        </AntSelect>
                    </FormWrapperInputComponent>
                </Wrapper>
                <Divider /> */}
                {/* <Wrapper className="col-md-6">
                    <FormWrapperInputComponent
                        isRequired={'right'}
                        isValidation={true}
                        dataValidation={tour.highlight}
                        validation={validation.highlight}
                        labelTitle={t(`item.tour.highlight`)}
                        messageBelowInput={true}
                    >
                        <RichTextEditor
                            editor={ClassicEditor}
                            data={tour.highlight || ""}
                            config={{ uploadDirectory: UPLOAD_DIRECTORY.TOUR_THUMB }}
                            onChange={(event, editor) => {
                                const value = editor.getData();
                                return this.props.onChange('highlight', value);
                            }}
                        />
                    </FormWrapperInputComponent>
                </Wrapper>
                <Wrapper className="col-md-6">
                    <FormWrapperInputComponent
                        isRequired={'right'}
                        isValidation={true}
                        dataValidation={tour.description}
                        validation={validation.description}
                        labelTitle={t(`item.tour.description`)}
                        messageBelowInput={true}
                    >
                        <RichTextEditor
                            editor={ClassicEditor}
                            data={tour.description || ""}
                            config={{ uploadDirectory: UPLOAD_DIRECTORY.TOUR_THUMB }}
                            onChange={(event, editor) => {
                                const value = editor.getData();
                                return this.props.onChange('description', value);
                            }}
                        />
                    </FormWrapperInputComponent>
                </Wrapper> */}
                {/* Start content tab */}

                <Divider />
                <Wrapper className="col-md-12">
                    <Tabs
                        // hideAdd
                        onChange={this.onChange}
                        activeKey={this.state.activeKey}
                        className="tab-extra-infos"
                        type="editable-card"
                        onEdit={this.onEdit}
                    >
                    {this.props.tour.extraInfos && this.props.tour.extraInfos.map((info, index) => (
                        <TabPane 
                            tab={
                                <span 
                                    className={
                                        `tab-content ${validateTabContent[index] && (validateTabContent[index].title || validateTabContent[index].content) ? 'is-errors' : ''}`
                                    }
                                >
                                    {info.title}
                                </span>
                            } 
                            key={index}
                        >
                            <Wrapper className="col-md-6">
                                <FormWrapperInputComponent
                                    isRequired={'right'}
                                    isValidation={true}
                                    dataValidation={info.title}
                                    validation={validateTabContent[index]?.title}
                                    labelTitle={t(`item.tour.titleContent`)}
                                >
                                    <Input placeholder="" type={`text`}
                                        className={`form-control`}
                                        name={`title`} onChange={(e) => this.onChangeContent('title', e.target.value, index)}
                                        value={checkUndefine(info.title)} />
                                </FormWrapperInputComponent>
                            </Wrapper>
                            <Wrapper className="col-md-12">
                                <FormWrapperInputComponent
                                    isRequired={'right'}
                                    isValidation={true}
                                    dataValidation={info.content}
                                    validation={validateTabContent[index]?.content}
                                    labelTitle={t(`item.tour.content`)}
                                >
                                    <RichTextEditor
                                        editor={ClassicEditor}
                                        data={info.content || ""}
                                        config={{ uploadDirectory: UPLOAD_DIRECTORY.TOUR_THUMB }}
                                        onChange={(event, editor) => {
                                            const value = editor.getData();
                                            return this.onChangeContent('content', value, index);
                                        }}
                                    />
                                </FormWrapperInputComponent>
                            </Wrapper>
                        </TabPane>
                    ))}
                    </Tabs>
                </Wrapper>
                <Divider />
                <Wrapper className="col-md-10">
                    <TagSearch 
                        {...this.props}
                        tagSKUs={_tagSKUs}
                        loadDataTagGroup={this.props._loadDataTagGroup}
                        onAddTagGroup={this.props._onAddTagGroup}
                    />
                </Wrapper>
                <br/>
                <Wrapper
                    className="col-md-6" 
                    show={tour.type === ORDER.TYPES.VINWONDER_NEW.id}
                >
                    <FormWrapperInputComponent
                        messageBelowInput={true}
                        typeInput={true}
                        labelTitle={""}
                        visible={action !== DETAIL_ACTIONS.TRANSLATE}
                    >
                        <br/>
                        <b>{t(`item.tour.showTicketInfo.title`)}</b>
                        <br/>
                        <i>
                            {t(`item.tour.showTicketInfo.note`)}
                        </i>
                        <CheckboxGroup
                            className="checkbox-collaps"
                            options={this.getShowTicketInfo(tour.type)}
                            value={tour.showTicketInfo || []}
                            onChange={e => this.props.onChange('showTicketInfo', e)}
                        />
                    </FormWrapperInputComponent>
                        
                </Wrapper>
                {/* End content tab */}
            </Wrapper>
        )
    }

    onChangeContent = (field, value, index) => {
        const extraInfos = [...this.props.tour.extraInfos]
        extraInfos[index][field] = value.trimLeft()
        // this.setState({ extraInfos })
        this.props.onChange('extraInfos', extraInfos)
    }

    onChange = activeKey => {
        this.setState({ activeKey });
      };
    
    onEdit = (targetKey, action) => {
        this[action](targetKey);
    };

    add = () => {
        const { extraInfos } = this.props.tour
        extraInfos.push({ 
            title: 'Nội dung mới', 
            content: ''
        });
        // this.setState({ extraInfos })
        this.props.onChange('extraInfos', extraInfos)
    };

    remove = targetKey => {
        const extraInfos = [...this.props.tour.extraInfos];
        const indexDelele = parseInt(targetKey)

        if(extraInfos.length <= 1) {
            return message.error('Phải giữ ít nhất một bài viết !')
        }

        if(!!extraInfos[indexDelele].content) {
            return message.error('Không thể xoá bài viết đang có nội dung!')
        }

        extraInfos.splice(indexDelele, 1)
        this.setState({ 
            activeKey: (indexDelele > 0 ? indexDelele - 1 : indexDelele).toString() 
        });
        this.props.onChange('extraInfos', extraInfos)
    };

    getEnumLengthOfTour = (value) => {
        const { t } = this.props
        let str = t(`item.tour.enumLengthOfTour`)
        if (!value) {
            return ''
        }
        const [days, nights] = value.split('.')
        var mapObj = {
            days: days || 0,
            nights: nights || 0,

        };
        str = str.replace(/days|nights/gi, function (matched) {
            return mapObj[matched];
        });
        return str
    }

    onChangeTourName = (e) => {
        const value = e.target.value;
        const urlSlug = stringToUrlSlug(value);
        const isUpdatingDetail = this.props.action !== DETAIL_ACTIONS.UPDATE;
        if (!this.state.urlSlugEdited && isUpdatingDetail) {
            this.props.onChange('urlSlug', urlSlug)
        }
        return this.props.onChange('tourName', value);
    }

    onChangeType = (value) => {
        const { action } = this.props;
        this.props.onChange('type', value);
        if(action === DETAIL_ACTIONS.CREATE){
            if(value === ORDER.TYPES.VINWONDER_NEW.id){
                this.props.onChange('channel', [TOUR_ENUM.CHANNELS.VinWonders.value]);
            }else {
                const channels = this.getChannels(value)
                this.props.onChange('channel', channels.map(x=>x.value));
            }
        }
    }

    onChangeDeparture = (id) => {
        const departure = find(this.props.departures || [], item => item.id === id);
        return departure && this.props.onChange('departure', departure);
    }

    onChangeDestination = (id) => {
        const destination = find(this.props.destinations || [], item => item.id === id);
        return destination && this.props.onChange('destination', destination);
    }

    onSelectDateRange = (data, fieldStartDate, fieldEndDate) => {
        this.props.onChange(fieldStartDate, data.fullValue[0]);
        this.props.onChange(fieldEndDate, data.fullValue[1]);
    }

    onChangeUrlSlug = e => {
        const value = e.target.value || '';
        this.setState({ urlSlugEdited: !!value })
        return this.props.onChange('urlSlug', formatUrlSlug(value))
    }

    onChangeTourTypes = (ids) => {
        const { tourTypes } = this.props;
        const types = ids.map(id => find(tourTypes, t => t.id === id)).filter(i => !!i);
        return this.props.onChange('tourTypes', types)
    }

    selectFilterSearch = (input, option) => {
        const textOption = option.props.children.toLowerCase() || '';
        const optionText = vietnameseStringToUnicode(textOption);
        const inputText = vietnameseStringToUnicode(input.toLowerCase());
        return optionText.indexOf(inputText) >= 0;
    };

    onChangeTagSKUVW = (ids) => {
        const { tagsSKUVW } = this.props;
        const tagsSKUVWSelected = ids.map(id => find(tagsSKUVW, t => t.id === id)).filter(i => !!i);
        return this.props.onChange('tagsSKUVW', tagsSKUVWSelected)
    }

    disabledSaleDate = (current) => {
        const { cutOffDate, stayStartDate, stayEndDate } = this.props.tour
        const disabledStart = moment(stayStartDate).subtract(cutOffDate, 'days');
        const disabledEnd = moment(stayEndDate).subtract(cutOffDate - 1, 'days');
        return current && (current <= moment(disabledStart) || current >= moment(disabledEnd));
    }

    disabledPublishDate = (current) => {
        return current && current <= moment().add(-1, 'day');
    }

    renderInfoTooltip(title, content, className) {
        return (
            <Tooltip key={ Math.random() } title={ title }>
                { content }
                <Icon className={ className } type="info-circle"/>
            </Tooltip>
        )
    }

}

GeneralInfo.defaultProps = {
    onChange: (fieldName, value) => { },
    onCreateTourType: type => { },
    onUpdateTourType: type => { },
    onDeleteTourType: type => { },
    tourTypes: [],
    departures: [],
    destinations: [],
    supplierSelectData: {},
}
